if ( window.wp && window.wp.ajax ) {

    const { registerBlockType, createBlock } = window.wp.blocks;
    const { select, dispatch } = window.wp.data;
    const { InspectorControls, RichText, InnerBlocks } = window.wp.editor;
    const { PanelBody, TextControl, SelectControl, CheckboxControl } = window.wp.components;

    function getHeadingTag(headingTag) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(headingTag) !== -1 ? headingTag : 'h2';
    }

    function getHeadingClasses(attributes) {
        return 'experience-heading' + (attributes.borderBottom ? ' border-bottom border-2 border-dark pb-4' : '');
    }

    registerBlockType('custom-gutenberg/section-heading', {
        // built-in attributes
        title: 'Section Heading',
        description: 'Section heading with an eyebrow and optional number.',
        icon: 'heading',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            eyebrow: { type: 'string', default: '' },
            title: { type: 'string', default: '' },
            headingTag: { type: 'string', default: 'h2' },
            textCase: { type: 'string', default: 'uppercase' },
            showNumber: { type: 'boolean', default: false },
            showButton: { type: 'boolean', default: false },
            buttonType: { type: 'string', default: 'normal' },
            hideOnMobile: { type: 'boolean', default: false },
            borderBottom: { type: 'boolean', default: false },
            number: { type: 'string', default: '01' }
        },

        // built-in functions
        edit({ attributes, setAttributes, clientId }) {
            const { eyebrow, title, headingTag, textCase, showNumber, number } = attributes;

            function onButtonTypeChange(buttonType) {
                const blocks = select('core/block-editor').getBlocks(clientId);
                const button = createBlock(buttonType === 'outline' ? 'custom-gutenberg/cta-outline' : 'custom-gutenberg/cta', blocks.length ? blocks[0].attributes : {});
                setAttributes({ buttonType: buttonType });
                dispatch('core/block-editor').replaceInnerBlocks(clientId, [button], false);
            }

            function onRightContentChange(value) {
                setAttributes({ showNumber: value === 'number', showButton: value === 'button' });
                if (value === 'button' && !select('core/block-editor').getBlocks(clientId).length) {
                    onButtonTypeChange(attributes.buttonType);
                }
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Settings">
                        <SelectControl
                            label="Heading level"
                            value={ headingTag }
                            options={ ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map(tag => ({ label: tag.toUpperCase(), value: tag })) }
                            onChange={ headingTag => setAttributes({ headingTag: headingTag }) }
                        />
                        <CheckboxControl
                            label="Uppercase"
                            checked={ textCase === 'uppercase' }
                            onChange={ checked => setAttributes({ textCase: checked ? 'uppercase' : '' }) }
                        />
                        <SelectControl
                            label="Right content"
                            value={ attributes.showButton ? 'button' : showNumber ? 'number' : '' }
                            options={ [{ label: 'None', value: '' }, { label: 'Number', value: 'number' }, { label: 'Button', value: 'button' }] }
                            onChange={ onRightContentChange }
                        />
                        { attributes.showButton && <SelectControl label="Button style" value={ attributes.buttonType } options={ [{ label: 'Normal', value: 'normal' }, { label: 'Outline', value: 'outline' }] } onChange={ onButtonTypeChange } /> }
                        <CheckboxControl label="Hide section heading on mobile" checked={ attributes.hideOnMobile } onChange={ hideOnMobile => setAttributes({ hideOnMobile: hideOnMobile }) } />
                        <CheckboxControl label="Dark bottom border" checked={ attributes.borderBottom } onChange={ borderBottom => setAttributes({ borderBottom: borderBottom }) } />
                        { showNumber && <TextControl label="Number or text" value={ number } onChange={ number => setAttributes({ number: number }) } /> }
                    </PanelBody>
                </InspectorControls>,
                <div key="preview" className={ getHeadingClasses(attributes) }>
                    <div>
                        <RichText
                            tagName="span"
                            allowedFormats={ ['core/bold', 'core/italic', 'core/link', 'core/text-color'] }
                            className="eyebrow"
                            value={ eyebrow }
                            placeholder="Eyebrow"
                            onChange={ eyebrow => setAttributes({ eyebrow: eyebrow }) }
                        />
                        <RichText
                            tagName={ getHeadingTag(headingTag) }
                            allowedFormats={ ['core/bold', 'core/italic', 'core/link', 'core/text-color'] }
                            className={ textCase === 'uppercase' ? 'text-uppercase' : undefined }
                            value={ title }
                            placeholder="Heading"
                            onChange={ title => setAttributes({ title: title }) }
                        />
                    </div>
                    { !attributes.showButton && showNumber && <span className="experience-number" aria-hidden="true">{ number }</span> }
                    <div style={ { display: attributes.showButton ? undefined : 'none' } }>
                        <InnerBlocks allowedBlocks={ ['custom-gutenberg/cta', 'custom-gutenberg/cta-outline'] } templateLock="all" />
                    </div>
                </div>
            ]);
        },

        save({ attributes }) {
            const { eyebrow, title, headingTag, textCase, showNumber, number } = attributes;

            return (
                <div className={ getHeadingClasses(attributes) + (attributes.hideOnMobile ? ' d-none d-md-flex' : '') }>
                    <div>
                        <span className="eyebrow"><RichText.Content value={ eyebrow } /></span>
                        <RichText.Content
                            tagName={ getHeadingTag(headingTag) }
                            className={ textCase === 'uppercase' ? 'text-uppercase' : undefined }
                            value={ title }
                        />
                    </div>
                    { !attributes.showButton && showNumber && <span className="experience-number" aria-hidden="true">{ number }</span> }
                    { attributes.showButton && <div><InnerBlocks.Content /></div> }
                </div>
            );
        },
        deprecated: [{
            attributes: {
                eyebrow: { type: 'string', default: '' },
                title: { type: 'string', default: '' },
                headingTag: { type: 'string', default: 'h2' },
                textCase: { type: 'string', default: 'uppercase' },
                showNumber: { type: 'boolean', default: false },
                number: { type: 'string', default: '01' }
            },
            migrate(attributes) {
                return { ...attributes, textCase: attributes.textCase === 'uppercase' ? 'uppercase' : '' };
            },
            save({ attributes }) {
                const { eyebrow, title, headingTag, textCase, showNumber, number } = attributes;
                return (
                    <div className="experience-heading">
                        <div>
                            <span className="eyebrow"><RichText.Content value={ eyebrow } /></span>
                            <RichText.Content tagName={ getHeadingTag(headingTag) } className={ textCase === 'lowercase' ? 'text-lowercase' : 'text-uppercase' } value={ title } />
                        </div>
                        { showNumber && <span className="experience-number" aria-hidden="true">{ number }</span> }
                    </div>
                );
            }
        }]
    });
}
